import React, { useEffect, useState } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
  Badge,
} from "reactstrap"
import { ToastContainer, toast } from "react-toastify"
import axios from "axios"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import Select from "react-select"

const Coupons = () => {
  const [modal_small, setmodal_small] = useState(false)

  function tog_small() {
    setmodal_small(!modal_small)
    removeBodyCss()
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  console.log(datas)

  const [coup, setcoup] = useState([])
  const [theaters, setTheaters] = useState([]) // State to store theaters from API
  const [form, setform] = useState({
    theaters: [],
    slots: [],
    days: [],
    discountType: "",
    value: "",
    title: "",
    couponCode: "",
    couponCodeType: "",
    amount: "",
    description: "",
    fromDate: "",
    toDate: "",
    websiteFor: "",
  })
  const [form1, setform1] = useState({
    theaters: [],
    slots: [],
    days: [],
    discountType: "",
    value: "",
    title: "",
    couponCode: "",
    couponCodeType: "",
    amount: "",
    description: "",
    fromDate: "",
    toDate: "",
    websiteFor: "",
  })

  // Fetch theaters from API
  const fetchTheaters = async () => {
    try {
      const response = await axios.post("https://api.carnivalcastle.com/v1/carnivalApi/web/getalltheatres/forweb")
      if (response.data.success) {
        setTheaters(response.data.theatres)
      }
    } catch (error) {
      console.error("Error fetching theaters:", error)
      toast.error("Failed to fetch theaters")
    }
  }

  // Convert theaters to options for react-select
  const theaterOptions = theaters.map(theater => ({
    value: theater._id,
    label: theater.name,
  }))

  const slotOptions = [
    { value: "morning", label: "Morning (9AM-12PM)" },
    { value: "afternoon", label: "Afternoon (12PM-5PM)" },
    { value: "evening", label: "Evening (5PM-9PM)" },
    { value: "night", label: "Night (9PM-12AM)" },
  ]

  const dayOptions = [
    { value: "monday", label: "Monday" },
    { value: "tuesday", label: "Tuesday" },
    { value: "wednesday", label: "Wednesday" },
    { value: "thursday", label: "Thursday" },
    { value: "friday", label: "Friday" },
    { value: "saturday", label: "Saturday" },
    { value: "sunday", label: "Sunday" },
  ]

  const discountTypeOptions = [
    { value: "percentage", label: "Percentage" },
    { value: "fixed", label: "Fixed Amount" },
    { value: "freeTicket", label: "Free Ticket" },
  ]

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  const handleTheaterChange = selectedOptions => {
    setform({ ...form, theaters: selectedOptions })
  }

  const handleSlotChange = selectedOptions => {
    setform({ ...form, slots: selectedOptions })
  }

  const handleDayChange = selectedOptions => {
    setform({ ...form, days: selectedOptions })
  }

  const handleDiscountTypeChange = selectedOption => {
    setform({ ...form, discountType: selectedOption.value, value: "" })
  }

  const handleTheaterChange1 = selectedOptions => {
    setform1({ ...form1, theaters: selectedOptions })
  }

  const handleSlotChange1 = selectedOptions => {
    setform1({ ...form1, slots: selectedOptions })
  }

  const handleDayChange1 = selectedOptions => {
    setform1({ ...form1, days: selectedOptions })
  }

  const handleDiscountTypeChange1 = selectedOption => {
    setform1({ ...form1, discountType: selectedOption.value, value: "" })
  }

  const getAllbcoupons = () => {
    var token = datas
    axios
      .post(
        URLS.GetCoupon,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setcoup(res.data.coupons)
      })
  }

  const addcoupons = () => {
    var token = datas
    const dataArray = {
      title: form.title,
      couponCode: form.couponCode,
      couponCodeType: form.couponCodeType,
      amount: form.amount,
      description: form.description,
      fromDate: form.fromDate,
      toDate: form.toDate,
      websiteFor: form.websiteFor,
      theaters: form.theaters.map(t => t.value),
      slots: form.slots.map(s => s.value),
      days: form.days.map(d => d.value),
      discountType: form.discountType,
      value: form.value,
    }

    axios
      .post(URLS.AddCoupon, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            getAllbcoupons()
            clearForm()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        }
      )
  }

  const getpopup = data => {
    // Convert array data to select options format
    const formattedData = {
      ...data,
      theaters: data.theaters
        ? data.theaters.map(t => ({
          value: t._id,
          label: t.name
        }))
        : [],
      slots: data.slots ? data.slots.map(s => ({ value: s, label: s })) : [],
      days: data.days ? data.days.map(d => ({ value: d, label: d })) : [],
    }
    setform1(formattedData)
    tog_small()
  }

  const editcoupon = () => {
    var token = datas
    var formid = form1._id
    const dataArray = {
      title: form1.title,
      couponCode: form1.couponCode,
      couponCodeType: form1.couponCodeType,
      amount: form1.amount,
      description: form1.description,
      fromDate: form1.fromDate,
      toDate: form1.toDate,
      websiteFor: form1.websiteFor,
      theaters: form1.theaters.map(t => t.value),
      slots: form1.slots.map(s => s.value),
      days: form1.days.map(d => d.value),
      discountType: form1.discountType,
      value: form1.value,
    }

    axios
      .put(URLS.UpdateCoupon + "/" + formid, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            getAllbcoupons()
            setmodal_small(false)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        }
      )
  }

  const handleSubmit = e => {
    e.preventDefault()
    addcoupons()
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    editcoupon()
  }

  const deletebenners = data => {
    var token = datas
    var remid = data._id
    axios
      .delete(URLS.DeleteCoupon + "/" + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            getAllbcoupons()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        }
      )
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      deletebenners(data)
    }
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = coup.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(coup.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  useEffect(() => {
    getAllbcoupons()
    fetchTheaters() // Fetch theaters when component mounts
  }, [])

  const clearForm = () => {
    setform({
      theaters: [],
      slots: [],
      days: [],
      discountType: "",
      value: "",
      title: "",
      couponCode: "",
      couponCodeType: "",
      amount: "",
      description: "",
      fromDate: "",
      toDate: "",
      websiteFor: "",
      status: "",
    })
  }

  const [search, setsearch] = useState([])

  const searchAll = e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    var token = datas
    axios
      .post(
        URLS.GeCouponSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setcoup(res.data.coupons)
      })
  }

  const [dds, setdds] = useState([])

  const handleChangedates = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)

    const tomorrow = new Date(e.target.value)
    tomorrow.setDate(tomorrow.getDate() + 1)
    setdds(tomorrow.toISOString().split("T")[0])
  }

  const [dds1, setdds1] = useState([])

  const handleChangedates1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)

    const tomorrow = new Date(e.target.value)
    tomorrow.setDate(tomorrow.getDate() + 1)
    setdds1(tomorrow.toISOString().split("T")[0])
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  // Helper function to display arrays as badges
  const renderArrayAsBadges = (array, maxItems = 2) => {
    if (!array || array.length === 0) return "None"

    // Handle theater objects with name property
    const displayArray = array.map(item =>
      typeof item === 'object' && item.name ? item.name : item
    )

    if (displayArray.length <= maxItems) {
      return displayArray.map((item, index) => (
        <Badge key={index} color="primary" className="me-1 mb-1">
          {item}
        </Badge>
      ))
    }

    return (
      <>
        {displayArray.slice(0, maxItems).map((item, index) => (
          <Badge key={index} color="primary" className="me-1 mb-1">
            {item}
          </Badge>
        ))}
        <Badge color="info" className="mb-1">
          +{displayArray.length - maxItems} more
        </Badge>
      </>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Carnival Castle Admin" breadcrumbItem="Coupons" />
          <Row>
            {Roles.CouponsAdd || Roles?.accessAll === true ? (
              <>
                <Col md={4}>
                  <Card>
                    <CardHeader className="bg-white">
                      <CardTitle>Add Coupon</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Form
                        onSubmit={e => {
                          handleSubmit(e)
                        }}
                      >
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input2">
                            Title <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input2"
                            placeholder="Enter Title"
                            required
                            name="title"
                            value={form.title}
                            onChange={e => {
                              handleChange(e)
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input3">
                            Coupon Code <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input3"
                            placeholder="Enter Coupon Code"
                            required
                            name="couponCode"
                            value={form.couponCode}
                            onChange={e => {
                              handleChange(e)
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Coupon Code Type
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            name="couponCodeType"
                            value={form.couponCodeType}
                            onChange={e => {
                              handleChange(e)
                            }}
                            required
                            className="form-select"
                          >
                            <option value="">Select</option>
                            <option value="Price">Price</option>
                            <option value="Percentage">Percentage</option>
                          </select>
                        </div>
                        {form.couponCodeType == "Percentage" ? (
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input2">
                              Percentage % <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input2"
                              placeholder="Enter  Percentage"
                              required
                              name="amount"
                              value={form.amount}
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>
                        ) : (
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input2">
                              Price <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input2"
                              placeholder="Enter Price "
                              required
                              name="amount"
                              value={form.amount}
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>
                        )}

                        <div className="mb-3">
                          <Label for="websiteFor">
                            Website For <span className="text-danger">*</span>
                          </Label>
                          <select
                            name="websiteFor"
                            value={form.websiteFor}
                            onChange={e => {
                              handleChange(e)
                            }}
                            required
                            className="form-select"
                          >
                            <option value="">Select Website</option>
                            <option value="carnivalcastle">Carnival Castle</option>
                            <option value="bingenjoy">Bingenjoy</option>
                            <option value="both">Both</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <Label>
                            Theaters (Optional)
                          </Label>
                          <Select
                            isMulti
                            options={theaterOptions}
                            value={form.theaters}
                            onChange={handleTheaterChange}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select theaters..."
                          />
                        </div>

                        <div className="mb-3">
                          <Label>
                            Time Slots (Optional)
                          </Label>
                          <Select
                            isMulti
                            options={slotOptions}
                            value={form.slots}
                            onChange={handleSlotChange}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select time slots..."
                          />
                        </div>

                        <div className="mb-3">
                          <Label>
                            Days (Optional)
                          </Label>
                          <Select
                            isMulti
                            options={dayOptions}
                            value={form.days}
                            onChange={handleDayChange}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select days..."
                          />
                        </div>

                        <div className="mb-3">
                          <Label>
                            Discount Type <span className="text-danger">*</span>
                          </Label>
                          <Select
                            options={discountTypeOptions}
                            value={discountTypeOptions.find(option => option.value === form.discountType) || null}
                            onChange={handleDiscountTypeChange}
                            className="basic-select"
                            classNamePrefix="select"
                            placeholder="Select discount type..."
                          />
                        </div>

                        {form.discountType && (
                          <div className="mb-3">
                            <Label>
                              Discount Value <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type={form.discountType === "percentage" ? "number" : "text"}
                              className="form-control"
                              placeholder={
                                form.discountType === "percentage"
                                  ? "Enter percentage (e.g., 10)"
                                  : form.discountType === "fixed"
                                    ? "Enter fixed amount (e.g., 5.00)"
                                    : "Enter number of free tickets"
                              }
                              required
                              name="value"
                              value={form.value}
                              onChange={e => {
                                handleChange(e)
                              }}
                              min={form.discountType === "percentage" ? 0 : undefined}
                              max={form.discountType === "percentage" ? 100 : undefined}
                              step={form.discountType === "percentage" ? 1 : 0.01}
                            />
                          </div>
                        )}

                        <div className="mb-3">
                          <Label for="basicpill-firstname-input2">
                            From Date <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="basicpill-firstname-input2"
                            required
                            name="fromDate"
                            min={new Date().toISOString().split("T")[0]}
                            value={form.fromDate}
                            onChange={e => {
                              handleChangedates(e)
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input2">
                            Expire Date <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="basicpill-firstname-input2"
                            placeholder="Enter  Version"
                            required
                            name="toDate"
                            min={dds}
                            value={form.toDate}
                            onChange={e => {
                              handleChange(e)
                            }}
                          />
                        </div>

                        <div className="mb-3">
                          <Label for="basicpill-firstname-input2">
                            Description
                          </Label>
                          <textarea
                            rows={2}
                            className="form-control"
                            id="basicpill-firstname-input2"
                            placeholder="Enter Description"
                            name="description"
                            value={form.description}
                            onChange={e => {
                              handleChange(e)
                            }}
                            required
                          />
                        </div>

                        <div style={{ float: "right" }}>
                          <Button className="m-1" color="primary" type="submit">
                            Submit <i className="fas fa-check-circle"></i>
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </>
            ) : (
              ""
            )}

            <Col md={Roles.CouponsAdd || Roles?.accessAll === true ? 8 : 12}>
              <Card>
                <CardHeader className="bg-white">
                  <CardTitle>Coupons List</CardTitle>
                </CardHeader>

                <CardBody>
                  <div>
                    <div className="table-responsive">
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          className="form-control"
                          placeholder="Search.."
                          value={search.search}
                          onChange={searchAll}
                          name="search"
                        />
                      </div>
                      <Table className="table table-bordered mb-4 mt-5">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Title</th>
                            <th>Coupon Code</th>
                            <th>Coupon Type</th>
                            <th>Discount Type</th>
                            <th>Website For</th>
                            <th>Theaters</th>
                            <th>Time Slots</th>
                            <th>Days</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th style={{ width: "100px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key}>
                              <th>{(pageNumber) * 5 + key + 1}</th>
                              <td>{data.title}</td>
                              <td>{data.couponCode}</td>
                              <td>{data.couponCodeType}</td>
                              <td>
                                {data.discountType} {data.value && `(${data.value}${data.discountType === "percentage" ? "%" : data.discountType === "fixed" ? "₹" : ""})`}
                              </td>
                              <td>{data.websiteFor}</td>
                              <td>{renderArrayAsBadges(data.theaters)}</td>
                              <td>{renderArrayAsBadges(data.slots)}</td>
                              <td>{renderArrayAsBadges(data.days)}</td>
                              <td>{data.fromDate}</td>
                              <td>{data.toDate}</td>

                              <td>
                                {Roles.CouponsEdit || Roles?.accessAll === true ? (
                                  <>
                                    <Button
                                      onClick={() => {
                                        getpopup(data)
                                      }}
                                      className="mr-2"
                                      style={{ padding: "6px", margin: "3px" }}
                                      color="success"
                                      outline
                                    >
                                      <i className="bx bx-edit "></i>
                                    </Button>{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                                {Roles.CouponsDelete || Roles?.accessAll === true ? (
                                  <>
                                    <Button
                                      onClick={() => {
                                        manageDelete(data)
                                      }}
                                      style={{ padding: "6px", margin: "3px" }}
                                      color="danger"
                                      outline
                                    >
                                      <i className="bx bx-trash"></i>
                                    </Button>{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer />

        <Modal
          size="lg"
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Edit Coupon
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit1(e)
              }}
            >
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input2">
                      Title <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input2"
                      placeholder="Enter Title"
                      required
                      name="title"
                      value={form1.title}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Coupon Code Type<span className="text-danger">*</span>
                    </Label>
                    <select
                      name="couponCodeType"
                      value={form1.couponCodeType}
                      onChange={e => {
                        handleChange1(e)
                      }}
                      className="form-select"
                    >
                      <option value="Price">Price</option>
                      <option value="Percentage">Percentage</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <Label for="websiteFor">
                      Website For <span className="text-danger">*</span>
                    </Label>
                    <select
                      name="websiteFor"
                      value={form1.websiteFor}
                      onChange={e => {
                        handleChange1(e)
                      }}
                      required
                      className="form-select"
                    >
                      <option value="Carnival Castle">Carnival Castle</option>
                      <option value="Jumping Jungle">Jumping Jungle</option>
                      <option value="Both">Both</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <Label>
                      Theaters (Optional)
                    </Label>
                    <Select
                      isMulti
                      options={theaterOptions}
                      value={form1.theaters}
                      onChange={handleTheaterChange1}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select theaters..."
                    />
                  </div>

                  <div className="mb-3">
                    <Label>
                      Time Slots (Optional)
                    </Label>
                    <Select
                      isMulti
                      options={slotOptions}
                      value={form1.slots}
                      onChange={handleSlotChange1}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select time slots..."
                    />
                  </div>

                  <div className="mb-3">
                    <Label>
                      Days (Optional)
                    </Label>
                    <Select
                      isMulti
                      options={dayOptions}
                      value={form1.days}
                      onChange={handleDayChange1}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select days..."
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input3">
                      Coupon Code <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input3"
                      placeholder="Enter Coupon Code"
                      required
                      name="couponCode"
                      value={form1.couponCode}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>

                  {form1.couponCodeType == "Percentage" ? (
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input2">
                        Percentage % <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input2"
                        placeholder="Enter Percentage"
                        required
                        name="amount"
                        value={form1.amount}
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>
                  ) : (
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input2">
                        Price <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input2"
                        placeholder="Enter Price "
                        required
                        name="amount"
                        value={form1.amount}
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>
                  )}

                  <div className="mb-3">
                    <Label>
                      Discount Type <span className="text-danger">*</span>
                    </Label>
                    <Select
                      options={discountTypeOptions}
                      value={discountTypeOptions.find(option => option.value === form1.discountType) || null}
                      onChange={handleDiscountTypeChange1}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select discount type..."
                    />
                  </div>

                  {form1.discountType && (
                    <div className="mb-3">
                      <Label>
                        Discount Value <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type={form1.discountType === "percentage" ? "number" : "text"}
                        className="form-control"
                        placeholder={
                          form1.discountType === "percentage"
                            ? "Enter percentage (e.g., 10)"
                            : form1.discountType === "fixed"
                              ? "Enter fixed amount (e.g., 5.00)"
                              : "Enter number of free tickets"
                        }
                        required
                        name="value"
                        value={form1.value}
                        onChange={e => {
                          handleChange1(e)
                        }}
                        min={form1.discountType === "percentage" ? 0 : undefined}
                        max={form1.discountType === "percentage" ? 100 : undefined}
                        step={form1.discountType === "percentage" ? 1 : 0.01}
                      />
                    </div>
                  )}

                  <div className="mb-3">
                    <Label for="basicpill-firstname-input2">
                      From Date <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="date"
                      className="form-control"
                      id="basicpill-firstname-input2"
                      required
                      name="fromDate"
                      value={form1.fromDate}
                      onChange={e => {
                        handleChangedates1(e)
                      }}
                    />
                  </div>

                  <div className="mb-3">
                    <Label for="basicpill-firstname-input2">
                      Expire Date <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="date"
                      className="form-control"
                      id="basicpill-firstname-input2"
                      placeholder="Enter  Version"
                      required
                      name="toDate"
                      min={dds1}
                      value={form1.toDate}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>

                  <div className="mb-3">
                    <Label for="basicpill-firstname-input2">Description</Label>
                    <textarea
                      className="form-control"
                      id="basicpill-firstname-input2"
                      placeholder="Enter Description"
                      name="description"
                      value={form1.description}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>
                </Col>
              </Row>

              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="primary" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default Coupons